import { render, staticRenderFns } from "./site-identity.vue?vue&type=template&id=5d3d0fe1"
import script from "./site-identity.vue?vue&type=script&lang=js"
export * from "./site-identity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports